/**
 * CheTuo Web — Order API functions.
 * Reuses /api/shop-mobile/orders/* endpoints.
 */

import { apiClient, shopMobilePath } from './client';

export interface OrderListItem {
  id: string;
  status: string;
  totalAmount: string;
  remark: string | null;
  createdAt: string;
  customerName: string;
  customerPhone: string | null;
  vehiclePlate: string;
  vehicleBrand: string | null;
  vehicleModel: string | null;
}

export interface OrderListResponse {
  items: OrderListItem[];
  total: number;
  page: number;
  pageSize: number;
}

export interface OrderDetailItem {
  id: string;
  name: string;
  quantity: string;
  unitPrice: string;
  amount: string;
  remark: string | null;
}

export interface OrderDetail {
  id: string;
  status: string;
  totalAmount: string;
  remark: string | null;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
  items: OrderDetailItem[];
  customer: {
    id: string;
    name: string;
    phone: string | null;
  } | null;
  vehicle: {
    id: string;
    plate: string;
    vin: string | null;
    brand: string | null;
    model: string | null;
    year: number | null;
  } | null;
  allowedNextStatuses: string[];
}

export function listOrders(params?: {
  status?: string;
  q?: string;
  page?: number;
  pageSize?: number;
}): Promise<OrderListResponse> {
  const query: string[] = [];
  if (params?.status) query.push(`status=${encodeURIComponent(params.status)}`);
  if (params?.q) query.push(`q=${encodeURIComponent(params.q)}`);
  if (params?.page) query.push(`page=${params.page}`);
  if (params?.pageSize) query.push(`pageSize=${params.pageSize}`);
  const qs = query.length > 0 ? `?${query.join('&')}` : '';
  return apiClient.get<OrderListResponse>(shopMobilePath(`/orders${qs}`));
}

export function getOrderDetail(orderId: string): Promise<OrderDetail> {
  return apiClient.get<OrderDetail>(shopMobilePath(`/orders/${orderId}`));
}

export function updateOrderStatus(
  orderId: string,
  status: string,
): Promise<{ id: string; status: string }> {
  return apiClient.patch<{ id: string; status: string }>(
    shopMobilePath(`/orders/${orderId}/status`),
    { status },
  );
}
